import { render, staticRenderFns } from "./InvoiceStatusChart.vue?vue&type=template&id=07af04b6"
import script from "./InvoiceStatusChart.vue?vue&type=script&lang=js"
export * from "./InvoiceStatusChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports